import { render, staticRenderFns } from "./ForShowUserProfile.vue?vue&type=template&id=015e41d5&scoped=true&"
import script from "./ForShowUserProfile.vue?vue&type=script&lang=js&"
export * from "./ForShowUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./ForShowUserProfile.vue?vue&type=style&index=0&id=015e41d5&scoped=true&lang=scss&"
import style1 from "./ForShowUserProfile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015e41d5",
  null
  
)

export default component.exports